import React from 'react';
import { LanguageProvider } from '../components/LanguageContext';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { WhoWeHelp } from '../components/WhoWeHelp';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Testimonials } from '../components/Testimonials';
import { Hours } from '../components/Hours';
import { ContactForm } from '../components/ContactForm';
import { Location } from '../components/Location';
import { Footer } from '../components/Footer';
export function Home() {
  return <LanguageProvider data-id="element-246">
      <div className="min-h-screen bg-white font-body" data-id="element-247">
        <Header data-id="element-248" />

        <main data-id="element-249">
          <Hero data-id="element-250" />
          <Services data-id="element-251" />
          <WhoWeHelp data-id="element-252" />
          <WhyChooseUs data-id="element-253" />
          <Testimonials data-id="element-254" />

          {/* Contact & Location Section */}
          <section id="contact" className="py-14 md:py-20 bg-white relative border-t border-gray-100" data-id="element-255">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-256">
              <div className="grid lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-257">
                <div className="lg:col-span-1 space-y-8" data-id="element-258">
                  <Hours data-id="element-259" />
                  <Location data-id="element-260" />
                </div>
                <div className="lg:col-span-2" data-id="element-261">
                  <ContactForm data-id="element-262" />
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer data-id="element-263" />
      </div>
    </LanguageProvider>;
}